export const SEARCHBAR = 'SEARCHBAR';
export const SEARCHBARSTYLE = 'SEARCHBARSTYLE'; 
export const SUCCESSBAR = 'SUCCESSBAR'; 
export const TICKETID = 'TICKETID';
export const AUTH = 'AUTH';
export const USERNAMESTYLE = 'USERNAMESTYLE';
export const REUSERNAMESTYLE = 'REUSERNAMESTYLE';
export const USERTYPESTYLE = 'USERTYPESTYLE';
export const SCROLLSTOP = 'SCROLLSTOP';
export const PERMISSIONS = 'PERMISSIONS';
